module.exports = {
	"ti_6_101_2": {
		"caption": "ЭКОНОМ-1 К-1 Пн.О"
	},
	"ti_6_101_3": {
		"caption": "ЭКОНОМ-1 К-1 Вт.В"
	},
	"ti_6_101_4": {
		"caption": "ЭКОНОМ-1 К-1 Вт.О"
	},
	"ti_6_101_5": {
		"caption": "ЭКОНОМ-1 К-1 Ср.В"
	},
	"ti_6_101_6": {
		"caption": "ЭКОНОМ-1 К-1 Ср.О"
	},
	"ti_6_101_7": {
		"caption": "ЭКОНОМ-1 К-1 Чт.В"
	},
	"ti_6_101_8": {
		"caption": "ЭКОНОМ-1 К-1 Чт.О"
	},
	"ti_6_101_9": {
		"caption": "ЭКОНОМ-1 К-1 Пт.В"
	},
	"ti_6_101_10": {
		"caption": "ЭКОНОМ-1 К-1 Пт.О"
	},
	"ti_6_101_11": {
		"caption": "ЭКОНОМ-1 К-1 Сб.В"
	},
	"ti_6_101_12": {
		"caption": "ЭКОНОМ-1 К-1 Сб.О"
	},
	"ti_6_101_13": {
		"caption": "ЭКОНОМ-1 К-1 Вс.В"
	},
	"ti_6_101_14": {
		"caption": "ЭКОНОМ-1 К-1 Вс.О"
	},
	"ti_6_101_21": {
		"caption": "ЭКОНОМ-1 К-2 Пн.В"
	},
	"ti_6_101_22": {
		"caption": "ЭКОНОМ-1 К-2 Пн.О"
	},
	"ti_6_101_23": {
		"caption": "ЭКОНОМ-1 К-2 Вт.В"
	},
	"ti_6_101_24": {
		"caption": "ЭКОНОМ-1 К-2 Вт.О"
	},
	"ti_6_101_25": {
		"caption": "ЭКОНОМ-1 К-2 Ср.В"
	},
	"ti_6_101_26": {
		"caption": "ЭКОНОМ-1 К-2 Ср.О"
	},
	"ti_6_101_27": {
		"caption": "ЭКОНОМ-1 К-2 Чт.В"
	},
	"ti_6_101_28": {
		"caption": "ЭКОНОМ-1 К-2 Чт.О"
	},
	"ti_6_101_29": {
		"caption": "ЭКОНОМ-1 К-2 Пт.В"
	},
	"ti_6_101_30": {
		"caption": "ЭКОНОМ-1 К-2 Пт.О"
	},
	"ti_6_101_31": {
		"caption": "ЭКОНОМ-1 К-2 Сб.В"
	},
	"ti_6_101_32": {
		"caption": "ЭКОНОМ-1 К-2 Сб.О"
	},
	"ti_6_94_5": {
		"caption": "КОНТУР-1 тепловая мощность"
	},
	"ti_6_94_7": {
		"caption": "КОНТУР-1 температура в подающем трубопроводе",
		"point": "1"
	},
	"ti_6_94_8": {
		"caption": "КОНТУР-1 температура в обратном трубопроводе",
		"point": "1"
	},
	"ti_6_94_9": {
		"caption": "КОНТУР-2 температура в подающем трубопроводе",
		"point": "1"
	},
	"ti_6_94_10": {
		"caption": "КОНТУР-2 температура в обратном трубопроводе",
		"point": "1"
	},
	"ti_6_94_14": {
		"caption": "КОНТУР-1 суммарный объемный расход"
	},
	"ti_6_94_16": {
		"caption": "КОНТУР-1 суммарный массовый расход"
	},
	"ti_6_94_18": {
		"caption": "КОНТУР-1 суммарная энергия"
	},
	"ti_6_94_21": {
		"caption": "FORT-1 время работы теплосчетчика"
	},
	"ti_6_94_22": {
		"caption": "FORT-1 время работы с ошибкой теплосчетчика"
	},
	"ti_6_94_23": {
		"caption": "КОНТУР-1 массовый расход"
	},
	"ti_6_94_24": {
		"caption": "КОНТУР-2 массовый расход"
	},
	"ti_6_94_25": {
		"caption": "КОНТУР-1 объемный расход"
	},
	"ti_6_94_26": {
		"caption": "КОНТУР-2 объемный расход"
	},
	"ti_6_94_27": {
		"caption": "КОНТУР-1 Расход Т/Э за час"
	},
	"ti_6_94_29": {
		"caption": "КОНТУР-1 Расход Т/Э за 24ч"
	},
	"ti_6_94_31": {
		"caption": "КОНТУР-1 объемный расход(час)"
	},
	"ti_6_94_33": {
		"caption": "КОНТУР-1 температура в подающем трубопр(час)"
	},
	"ti_6_94_34": {
		"caption": "КОНТУР-1 температура в обратном трубопр(час)"
	},
	"ti_6_94_37": {
		"caption": "КОНТУР-1 количество теплоты(час)"
	},
	"ti_6_94_42": {
		"caption": "КОНТУР-1 Время работы с ошибкой(час)"
	},
	"ti_6_94_51": {
		"caption": "КОНТУР-1 объемный расход в подающем трубопр(сут)"
	},
	"ti_6_94_53": {
		"caption": "КОНТУР-1 температура в подающем трубопр(сут)"
	},
	"ti_6_94_54": {
		"caption": "КОНТУР-1 температура в обратном трубопр(сут)"
	},
	"ti_6_94_57": {
		"caption": "КОНТУР-1 количество теплоты(сут)"
	},
	"ti_6_94_62": {
		"caption": "КОНТУР-1 Время работы с ошибкой(сут)"
	},
	"ti_6_96_1": {
		"caption": "ЭКОНОМ-1 Термометр-1 Температура Н.В.",
		"point": "1"
	},
	"ti_6_96_2": {
		"caption": "ЭКОНОМ-1 Термометр-2 Температура подачи нагрузки",
		"point": "1"
	},
	"ti_6_96_3": {
		"caption": "ЭКОНОМ-1 Термометр-3 Температура подачи в ТО",
		"point": "1"
	},
	"ti_6_96_4": {
		"caption": "ЭКОНОМ-1 Термометр-4 Температура в баке",
		"point": "1"
	},
	"ti_6_96_5": {
		"caption": "ЭКОНОМ-1 Термометр-5 Температура подачи из ТО",
		"point": "1"
	},
	"ti_6_96_6": {
		"caption": "ЭКОНОМ-1 Термометр-6 Температура обратки из ТО",
		"point": "1"
	},
	"ti_6_96_7": {
		"caption": "ЭКОНОМ-1 Термометр-7 Температура в ИТП",
		"point": "1"
	},
	"ti_6_96_8": {
		"caption": "ЭКОНОМ-1 Термометр-8 Температура в Отделе заказов",
		"point": "1"
	},
	"ti_6_96_9": {
		"caption": "ЭКОНОМ-1 Термометр-9",
		"point": "1"
	},
	"ti_6_96_10": {
		"caption": "ЭКОНОМ-1 Термометр-10"
	},
	"ti_6_96_11": {
		"caption": "ЭКОНОМ-1 Термометр-11"
	},
	"ti_6_96_21": {
		"caption": "ЭКОНОМ-1 Контур-1 Задание по температуре",
		"point": "1"
	},
	"ti_6_96_22": {
		"caption": "ЭКОНОМ-1 Контур-2 Задание по температуре",
		"point": "1"
	},
	"ti_6_96_23": {
		"caption": "ЭКОНОМ-1 Контур-3 Задание по температуре",
		"point": "1"
	},
	"ti_6_96_31": {
		"caption": "ЭКОНОМ-1 Контур-1 Температура снижения"
	},
	"ti_6_96_32": {
		"caption": "ЭКОНОМ-1 Контур-2 Температура снижения"
	},
	"ti_6_96_33": {
		"caption": "ЭКОНОМ-1 Контур-3 Температура снижения"
	},
	"ti_6_96_64": {
		"caption": "ЭКОНОМ-1 Контур-3 Положение клапана"
	},
	"ti_6_93_1": {
		"caption": "Сч.Э.В-1 ЭЩ-И Текущая активная энергия"
	},
	"ti_6_93_2": {
		"caption": "Сч.Э.В-1 ЭЩ-И T1 Aктивная энергия"
	},
	"ti_6_93_3": {
		"caption": "Сч.Э.В-1 ЭЩ-И T2 Aктивная энергия"
	},
	"ti_6_93_4": {
		"caption": "Сч.Э.В-1 ЭЩ-И T3 Aктивная энергия"
	},
	"ti_6_93_5": {
		"caption": "Сч.Э.В-1 ЭЩ-И T4 Aктивная энергия"
	},
	"ti_6_93_21": {
		"caption": "Сч.Э.В-1 ЭЩ-И Текущая реактивная энергия"
	},
	"ti_6_93_101": {
		"caption": "Сч.Э.В-1 ЭЩ-И Активная мощность фаза\"А\""
	},
	"ti_6_93_102": {
		"caption": "Сч.Э.В-1 ЭЩ-И Активная мощность фаза\"В\""
	},
	"ti_6_93_103": {
		"caption": "Сч.Э.В-1 ЭЩ-И Активная мощность фаза \"C\""
	},
	"ti_6_93_121": {
		"caption": "Сч.Э.В-1 ЭЩ-И фаза \"А\" Текущая реактивная мощность"
	},
	"ti_6_93_141": {
		"caption": "Сч.Э.В-1 ЭЩ-И Напряжение фаза \"А\""
	},
	"ti_6_93_161": {
		"caption": "Сч.Э.В-1 ЭЩ-И Коэфф.мощности фаза \"А\""
	},
	"ti_6_93_162": {
		"caption": "Сч.Э.В-1 ЭЩ-И Коэфф.мощности фаза\"В\""
	},
	"ti_6_93_163": {
		"caption": "Сч.Э.В-1 ЭЩ-И Коэфф.мощности фаза \"С\""
	},
	"ti_6_99_1": {
		"caption": "ЭКОНОМ-1 Контур-1 -25Град"
	},
	"ti_6_99_7": {
		"caption": "ЭКОНОМ-1 Контур-1 +5Град"
	},
	"ti_6_99_8": {
		"caption": "ЭКОНОМ-1 Контур-1 +10Град"
	},
	"ti_6_99_11": {
		"caption": "ЭКОНОМ-1 Контур-2 -25Град"
	},
	"ti_6_99_12": {
		"caption": "ЭКОНОМ-1 Контур-2 -20Град"
	},
	"ti_6_99_13": {
		"caption": "ЭКОНОМ-1 Контур-2 -15Град"
	},
	"ti_6_99_21": {
		"caption": "ЭКОНОМ-1 Контур-3 -25Град"
	},
	"ti_6_99_22": {
		"caption": "ЭКОНОМ-1 Контур-3 -20Град"
	},
	"ti_6_99_23": {
		"caption": "ЭКОНОМ-1 Контур-3 -15Град"
	},
	"ti_6_99_24": {
		"caption": "ЭКОНОМ-1 Контур-3 -10Град"
	},
	"ti_6_99_25": {
		"caption": "ЭКОНОМ-1 Контур-3 -5Град"
	},
	"ti_6_100_3": {
		"caption": "ЭКОНОМ-1 Н-3 Вт.Ут-В"
	},
	"ti_6_100_4": {
		"caption": "ЭКОНОМ-1 Н-3 Вт.Ут-О"
	},
	"ti_6_100_5": {
		"caption": "ЭКОНОМ-1 Н-3 Ср.Ут-В"
	},
	"ti_6_100_6": {
		"caption": "ЭКОНОМ-1 Н-3 Ср.Ут-О"
	},
	"ti_6_100_7": {
		"caption": "ЭКОНОМ-1 Н-3 Чт.Ут-В"
	},
	"ti_6_100_13": {
		"caption": "ЭКОНОМ-1 Н-3 Вс.Ут-В"
	},
	"ti_6_100_14": {
		"caption": "ЭКОНОМ-1 Н-3 Вс.Ут-О"
	},
	"ti_6_100_15": {
		"caption": "ЭКОНОМ-1 Н-3 Пн.Вч-В"
	},
	"ti_6_100_16": {
		"caption": "ЭКОНОМ-1 Н-3 Пн.Вч-О"
	},
	"ti_6_100_17": {
		"caption": "ЭКОНОМ-1 Н-3 Вт.Вч-В"
	},
	"ti_6_100_23": {
		"caption": "ЭКОНОМ-1 Н-3 Пт.Вч-В"
	},
	"ti_6_100_24": {
		"caption": "ЭКОНОМ-1 Н-3 Пт.Вч-О"
	},
	"ti_6_100_25": {
		"caption": "ЭКОНОМ-1 Н-3 Сб.Вч-В"
	},
	"ti_6_100_26": {
		"caption": "ЭКОНОМ-1 Н-3 Сб.Вч-О"
	},
	"ti_6_100_27": {
		"caption": "ЭКОНОМ-1 Н-3 Вс.Вч-В"
	},
	"ti_6_100_33": {
		"caption": "ЭКОНОМ-1 Н-4 Ср.Ут-В"
	},
	"ti_6_100_34": {
		"caption": "ЭКОНОМ-1 Н-4 Ср.Ут-О"
	},
	"ti_6_100_35": {
		"caption": "ЭКОНОМ-1 Н-4 Чт.Ут-В"
	},
	"ti_6_100_36": {
		"caption": "ЭКОНОМ-1 Н-4 Чт.Ут-О"
	},
	"ti_6_100_37": {
		"caption": "ЭКОНОМ-1 Н-4 Пт.Ут-В"
	},
	"ti_6_93_142": {
		"caption": "Сч.Э.В-1 ЭЩ-И Напряжение фаза\"В\""
	},
	"ti_6_93_143": {
		"caption": "Сч.Э.В-1 ЭЩ-И Напряжение фаза\"С\""
	},
	"ti_6_93_151": {
		"caption": "Сч.Э.В-1 ЭЩ-И Ток фаза\"А\""
	},
	"ti_6_93_152": {
		"caption": "Сч.Э.В-1 ЭЩ-И Ток фаза\"В\""
	},
	"ti_6_93_153": {
		"caption": "Сч.Э.В-1 ЭЩ-И Ток фаза\"С\""
	},
	"ti_6_99_2": {
		"caption": "ЭКОНОМ-1 Контур-1 -20Град"
	},
	"ti_6_99_3": {
		"caption": "ЭКОНОМ-1 Контур-1 -15Град"
	},
	"ti_6_99_4": {
		"caption": "ЭКОНОМ-1 Контур-1 -10Град"
	},
	"ti_6_99_5": {
		"caption": "ЭКОНОМ-1 Контур-1 -5Град"
	},
	"ti_6_99_6": {
		"caption": "ЭКОНОМ-1 Контур-1 +0Град"
	},
	"ti_6_99_14": {
		"caption": "ЭКОНОМ-1 Контур-2 -10Град"
	},
	"ti_6_99_15": {
		"caption": "ЭКОНОМ-1 Контур-2 -5Град"
	},
	"ti_6_99_16": {
		"caption": "ЭКОНОМ-1 Контур-2 +0Град"
	},
	"ti_6_99_17": {
		"caption": "ЭКОНОМ-1 Контур-2 +5Град"
	},
	"ti_6_99_18": {
		"caption": "ЭКОНОМ-1 Контур-2 +10Град"
	},
	"ti_6_99_26": {
		"caption": "ЭКОНОМ-1 Контур-3 +0Град"
	},
	"ti_6_99_27": {
		"caption": "ЭКОНОМ-1 Контур-3 +5Град"
	},
	"ti_6_99_28": {
		"caption": "ЭКОНОМ-1 Контур-3 +10Град"
	},
	"ti_6_100_1": {
		"caption": "ЭКОНОМ-1 Н-3 Пн.Ут-В"
	},
	"ti_6_100_2": {
		"caption": "ЭКОНОМ-1 Н-3 Пн.Ут-О"
	},
	"ti_6_100_8": {
		"caption": "ЭКОНОМ-1 Н-3 Чт.Ут-О"
	},
	"ti_6_100_9": {
		"caption": "ЭКОНОМ-1 Н-3 Пт.Ут-В"
	},
	"ti_6_100_10": {
		"caption": "ЭКОНОМ-1 Н-3 Пт.Ут-О"
	},
	"ti_6_100_11": {
		"caption": "ЭКОНОМ-1 Н-3 Сб.Ут-В"
	},
	"ti_6_100_12": {
		"caption": "ЭКОНОМ-1 Н-3 Сб.Ут-О"
	},
	"ti_6_100_18": {
		"caption": "ЭКОНОМ-1 Н-3 Вт.Вч-О"
	},
	"ti_6_100_19": {
		"caption": "ЭКОНОМ-1 Н-3 Ср.Вч-В"
	},
	"ti_6_100_20": {
		"caption": "ЭКОНОМ-1 Н-3 Ср.Вч-О"
	},
	"ti_6_100_21": {
		"caption": "ЭКОНОМ-1 Н-3 Чт.Вч-В"
	},
	"ti_6_100_22": {
		"caption": "ЭКОНОМ-1 Н-3 Чт.Вч-О"
	},
	"ti_6_100_28": {
		"caption": "ЭКОНОМ-1 Н-3 Вс.Вч-О"
	},
	"ti_6_100_29": {
		"caption": "ЭКОНОМ-1 Н-4 Пн.Ут-В"
	},
	"ti_6_100_30": {
		"caption": "ЭКОНОМ-1 Н-4 Пн.Ут-О"
	},
	"ti_6_100_31": {
		"caption": "ЭКОНОМ-1 Н-4 Вт.Ут-В"
	},
	"ti_6_100_32": {
		"caption": "ЭКОНОМ-1 Н-4 Вт.Ут-О"
	},
	"ti_6_100_38": {
		"caption": "ЭКОНОМ-1 Н-4 Пт.Ут-О"
	},
	"ti_6_100_39": {
		"caption": "ЭКОНОМ-1 Н-4 Сб.Ут-В"
	},
	"ti_6_100_40": {
		"caption": "ЭКОНОМ-1 Н-4 Сб.Ут-О"
	},
	"ti_6_100_41": {
		"caption": "ЭКОНОМ-1 Н-4 Вс.Ут-В"
	},
	"ti_6_100_42": {
		"caption": "ЭКОНОМ-1 Н-4 Вс.Ут-О"
	},
	"ti_6_100_43": {
		"caption": "ЭКОНОМ-1 Н-4 Пн.Вч-В"
	},
	"ti_6_100_44": {
		"caption": "ЭКОНОМ-1 Н-4 Пн.Вч-О"
	},
	"ti_6_100_45": {
		"caption": "ЭКОНОМ-1 Н-4 Вт.Вч-В"
	},
	"ti_6_100_46": {
		"caption": "ЭКОНОМ-1 Н-4 Вт.Вч-О"
	},
	"ti_6_100_47": {
		"caption": "ЭКОНОМ-1 Н-4 Ср.Вч-В"
	},
	"ti_6_100_53": {
		"caption": "ЭКОНОМ-1 Н-4 Сб.Вч-В"
	},
	"ti_6_100_54": {
		"caption": "ЭКОНОМ-1 Н-4 Сб.Вч-О"
	},
	"ti_6_100_55": {
		"caption": "ЭКОНОМ-1 Н-4 Вс.Вч-В"
	},
	"ti_6_100_56": {
		"caption": "ЭКОНОМ-1 Н-4 Вс.Вч-О"
	},
	"ti_6_96_12": {
		"caption": "dТэк",
		"point": "1"
	},
	"ti_6_100_48": {
		"caption": "ЭКОНОМ-1 Н-4 Ср.Вч-О"
	},
	"ti_6_100_49": {
		"caption": "ЭКОНОМ-1 Н-4 Чт.Вч-В"
	},
	"ti_6_100_50": {
		"caption": "ЭКОНОМ-1 Н-4 Чт.Вч-О"
	},
	"ti_6_100_51": {
		"caption": "ЭКОНОМ-1 Н-4 Пт.Вч-В"
	},
	"ti_6_100_52": {
		"caption": "ЭКОНОМ-1 Н-4 Пт.Вч-О"
	},
	"ti_6_96_13": {
		"caption": "dТтог",
		"point": "1"
	},
	"ti_6_96_14": {
		"caption": "dТтон",
		"point": "1"
	},
	"ti_6_96_15": {
		"caption": "dТн",
		"point": "1"
	},
	"ti_6_96_65": {
		"caption": "ЭКОНОМ-1 Уровень в БАКЕ"
	},
	"ti_6_91_1": {
		"caption": "Qп Расход подмеса"
	},
	"ti_6_91_2": {
		"caption": "Qэ Расзод через котел"
	},
	"ti_6_91_3": {
		"caption": "Qр Расзод через ТО"
	},
	"ti_6_93_104": {
		"caption": "Сч.Э Суммарная активная мощность"
	},
	"ti_6_126_23": {
		"caption": "Себестоимость Гкал за сутки"
	},
	"ti_6_126_24": {
		"caption": "Потребленная Э/Э за декаду"
	},
	"ti_6_126_25": {
		"caption": "Выработанная Т/Э за декаду"
	},
	"ti_6_126_26": {
		"caption": "Стоимость Э/Э за декаду"
	},
	"ti_6_126_27": {
		"caption": "Стоимость Т/Э за декаду"
	},
	"ti_6_127_1": {
		"caption": "Мощность генерации текущая"
	},
	"ti_6_127_2": {
		"caption": "Мощность генерации за прошедший час"
	},
	"ti_6_127_3": {
		"caption": "Мощность потребления текущая"
	},
	"ti_6_127_4": {
		"caption": "Мощность потребления за прошедший час"
	},
	"ti_6_127_5": {
		"caption": "Запас энергии в баке"
	},
	"ti_6_127_6": {
		"caption": "Дефицит энергии в баке"
	},
	"ti_6_127_7": {
		"caption": "Потери текущие"
	},
	"ti_6_127_8": {
		"caption": "Потери за прошедший час"
	},
	"ti_6_126_6": {
		"caption": "Стоимость кВт*ч Э/Э"
	},
	"ti_6_126_7": {
		"caption": "Коэффициент Т3"
	},
	"ti_6_126_33": {
		"caption": "Потребленная Э/Э T3 за декаду"
	},
	"ti_6_126_34": {
		"caption": "Потребленная Э/Э за весь период"
	},
	"ti_6_126_35": {
		"caption": "Выработанная Т/Э за весь период"
	},
	"ti_6_126_36": {
		"caption": "Стоимость Э/Э за весь период"
	},
	"ti_6_126_37": {
		"caption": "Стоимость Т/Э за весь период"
	},
	"ti_6_126_38": {
		"caption": "Экономия за весь период"
	},
	"ti_6_126_39": {
		"caption": "Себестоимость Гкал за весь период"
	},
	"ti_6_126_40": {
		"caption": "КПД системы за весь период"
	},
	"ti_6_126_41": {
		"caption": "Потребленная Э/Э за текущий сезон"
	},
	"ti_6_126_42": {
		"caption": "Выработанная Т/Э за текущий сезон"
	},
	"ti_6_126_8": {
		"caption": "Коэффициент Т2"
	},
	"ti_6_126_9": {
		"caption": "Коэффициент Т1"
	},
	"ti_6_126_10": {
		"caption": "Стоимость Гкал Т/Э"
	},
	"ti_6_126_11": {
		"caption": "Потребленная Э/Э за сутки"
	},
	"ti_6_126_12": {
		"caption": "Выработанная Т/Э за сутки"
	},
	"ti_6_126_13": {
		"caption": "КПД системы за сутки"
	},
	"ti_6_126_14": {
		"caption": "Потребленная Э/Э Т1 за сутки"
	},
	"ti_6_126_15": {
		"caption": "Потребленная Э/Э Т2 за сутки"
	},
	"ti_6_126_16": {
		"caption": "Потребленная Э/Э Т3 за сутки"
	},
	"ti_6_126_17": {
		"caption": "Стоимость Э/Э Т1 за сутки"
	},
	"ti_6_126_18": {
		"caption": "Стоимость Э/Э Т2 за сутки"
	},
	"ti_6_126_19": {
		"caption": "Стоимость Э/Э Т3 за сутки"
	},
	"ti_6_126_20": {
		"caption": "Стоимость Э/Э за сутки"
	},
	"ti_6_126_21": {
		"caption": "Стоимость Т/Э за сутки"
	},
	"ti_6_126_22": {
		"caption": "Экономия за сутки"
	},
	"ti_6_126_43": {
		"caption": "Стоимость Э/Э за текущий сезон"
	},
	"ti_6_126_44": {
		"caption": "Стоимость Т/Э за текущий сезон"
	},
	"ti_6_126_45": {
		"caption": "Экономия за текущий сезон"
	},
	"ti_6_126_46": {
		"caption": "Себестоимость Гкал за текущий сезон"
	},
	"ti_6_126_47": {
		"caption": "КПД системы за текущий сезон"
	},
	"ti_6_126_104": {
		"caption": "Дата внедрения - День",
		"point": 0
	},
	"ti_6_126_105": {
		"caption": "Дата внедрения - Месяц",
		"point": 0
	},
	"ti_6_126_106": {
		"caption": "Дата внедрения - Год",
		"point": 0
	},
	"ti_6_126_107": {
		"caption": "Дата возврата - День",
		"point": 0
	},
	"ti_6_126_108": {
		"caption": "Дата возврата - Месяц",
		"point": 0
	},
	"ti_6_126_28": {
		"caption": "Экономия за декаду"
	},
	"ti_6_126_29": {
		"caption": "Себестоимость Гкал за декаду"
	},
	"ti_6_126_30": {
		"caption": "КПД системы за декаду"
	},
	"ti_6_126_31": {
		"caption": "Потребленная Э/Э T1 за декаду"
	},
	"ti_6_126_32": {
		"caption": "Потребленная Э/Э T2 за декаду"
	},
	"ti_6_126_109": {
		"caption": "Дата возврата - Год"
	},
	"ti_6_126_110": {
		"caption": "Срок работы - Дни"
	},
	"ti_6_126_111": {
		"caption": "Срок окупаемости"
	},
	"ti_6_126_119": {
		"caption": "затраты на внедрение"
	},
	"ti_6_126_120": {
		"caption": "Затраты на эксплуатацию"
	},
	"ti_6_126_121": {
		"caption": "Затраты на внедрение"
	},
	"ti_6_126_122": {
		"caption": "Затраты на эксплуатацию"
	},
	"ti_6_126_123": {
		"caption": "Суммарные затраты"
	},
	"ti_6_126_124": {
		"caption": "СДней текущего сезона",
		"point": 0
	},
	"ti_6_94_20": {
		"caption": "КОНТУР-1 суммарная энергия"
	},
	"ti_6_93_122": {
		"caption": "Сч.Э.В-1 ЭЩ-И фаза\"В\" Текущая реактивная мощность"
	},
	"ti_6_93_123": {
		"caption": "Сч.Э.В-1 ЭЩ-И фаза \"С\" Текущая реактивная мощность"
	},
	"ti_6_101_1": {
		"caption": "ЭКОНОМ-1 К-1 Пн.В"
	},
	"ti_6_101_44": {
		"caption": "ЭКОНОМ-1 К-3 Вт.О"
	},
	"ti_6_101_45": {
		"caption": "ЭКОНОМ-1 К-3 Ср.В"
	},
	"ti_6_101_46": {
		"caption": "ЭКОНОМ-1 К-3 Ср.О"
	},
	"ti_6_101_47": {
		"caption": "ЭКОНОМ-1 К-3 Чт.В"
	},
	"ti_6_101_48": {
		"caption": "ЭКОНОМ-1 К-3 Чт.О"
	},
	"ti_6_101_49": {
		"caption": "ЭКОНОМ-1 К-3 Пт.В"
	},
	"ti_6_101_50": {
		"caption": "ЭКОНОМ-1 К-3 Пт.О"
	},
	"ti_6_101_51": {
		"caption": "ЭКОНОМ-1 К-3 Сб.В"
	},
	"ti_6_101_52": {
		"caption": "ЭКОНОМ-1 К-3 Сб.О"
	},
	"ti_6_101_53": {
		"caption": "ЭКОНОМ-1 К-3 Вс.В"
	},
	"ti_6_126_48": {
		"caption": "Потребленная Э/Э за прошедший сезон"
	},
	"ti_6_126_49": {
		"caption": "Выработанная Т/Э за прошедший сезон"
	},
	"ti_6_126_50": {
		"caption": "Стоимость Э/Э за прошедший сезон"
	},
	"ti_6_126_51": {
		"caption": "Стоимость Т/Э за прошедший сезон"
	},
	"ti_6_126_52": {
		"caption": "Экономия за прошедший сезон"
	},
	"ti_6_126_53": {
		"caption": "Себестоимость Гкал за прошедший сезон"
	},
	"ti_6_126_54": {
		"caption": "КПД системы за прошедший сезон"
	},
	"ti_6_126_101": {
		"caption": "Текущая дата - День",
		"point": 0
	},
	"ti_6_126_102": {
		"caption": "Текущая дата - Месяц",
		"point": 0
	},
	"ti_6_126_103": {
		"caption": "Текущая дата - Год",
		"point": 0
	},
	"ti_6_101_33": {
		"caption": "ЭКОНОМ-1 К-2 Вс.В"
	},
	"ti_6_101_34": {
		"caption": "ЭКОНОМ-1 К-2 Вс.О"
	},
	"ti_6_101_41": {
		"caption": "ЭКОНОМ-1 К-3 Пн.В"
	},
	"ti_6_101_42": {
		"caption": "ЭКОНОМ-1 К-3 Пн.О"
	},
	"ti_6_101_43": {
		"caption": "ЭКОНОМ-1 К-3 Вт.В"
	},
	"ti_6_101_54": {
		"caption": "ЭКОНОМ-1 К-3 Вс.О"
	},
	"ti_6_96_66": {
		"caption": "Средняя температура Н.В. За сутки"
	},
	"ti_6_127_9": {
		"caption": "Запас хода в баке"
	},
	"ti_6_127_10": {
		"caption": "Время работы EDISON-100"
	},
	"ti_6_127_11": {
		"caption": "Время работы EDISON-22"
	},
	"ti_6_127_12": {
		"caption": "Время работы Н-1"
	},
	"ti_6_127_13": {
		"caption": "Время работы Н-2"
	},
	"ti_6_127_14": {
		"caption": "Количесвто включений EDISON-100"
	},
	"ti_6_127_15": {
		"caption": "Количесвто включений EDISON-22"
	},
	"ti_6_127_16": {
		"caption": "Количесвто включений Н-1"
	},
	"ti_6_127_17": {
		"caption": "Количесвто включений Н-2"
	},
	"ti_6_127_18": {
		"caption": "Количесвто включений крана ТЦ"
	},
	"ti_6_127_19": {
		"caption": "Количесвто включений крана БА"
	},
	"ti_6_93_31": {
		"caption": "Сч.Э.В-1 ЭЩ-И Угол между фазами\"А\" и \"В\""
	},
	"ti_6_93_32": {
		"caption": "Сч.Э.В-1 ЭЩ-И Угол между фазами\"А\" и\"С\""
	},
	"ti_6_93_41": {
		"caption": "Сч.Э.В-1 ЭЩ-И Номер тарифа"
	},
	"tc_6_96_135": {
		"caption": "ЭКОНОМ-1 НАСОС-1 АВАРИЯ"
	},
	"tc_6_96_136": {
		"caption": "ЭКОНОМ-1 НАСОС-2 АВАРИЯ"
	},
	"tc_6_96_110": {
		"caption": "ЭКОНОМ-1 Уровень воды в баке аккумуляторе"
	},
	"tc_6_93_0": {
		"caption": "PI1. Нет связи"
	},
	"tc_6_93_200": {
		"caption": "Сч.Э.В-1 ЭЩ-И Нет связи"
	},
	"tc_6_93_201": {
		"caption": "EDISON-100 включен"
	},
	"tc_6_94_0": {
		"caption": "QI1. Нет связи"
	},
	"tc_6_94_200": {
		"caption": "FORT-1 Нет связи"
	},
	"tc_6_96_0": {
		"caption": "А1. Нет связи"
	},
	"tc_6_96_101": {
		"caption": "ЭКОНОМ-1 Н-1 Аварии НЕТ"
	},
	"tc_6_96_102": {
		"caption": "ЭКОНОМ-1 Н-2 Аварии НЕТ"
	},
	"tc_6_96_103": {
		"caption": "ЭКОНОМ-1 Кран ТЦ"
	},
	"tc_6_96_104": {
		"caption": "ЭКОНОМ-1 Эдисон-100 Авария"
	},
	"tc_6_96_105": {
		"caption": "ЭКОНОМ-1 DI-5"
	},
	"tc_6_96_106": {
		"caption": "ЭКОНОМ-1 Уровень 3"
	},
	"tc_6_96_107": {
		"caption": "ЭКОНОМ-1 Уровень 2"
	},
	"tc_6_96_108": {
		"caption": "ЭКОНОМ-1 Уровень 1"
	},
	"tc_6_96_109": {
		"caption": "ЭКОНОМ-1 Кран БА"
	},
	"tc_6_96_111": {
		"caption": "ЭКОНОМ-1 DO-1"
	},
	"tc_6_127_102": {
		"caption": "Работа ТТ котла"
	},
	"tc_6_96_113": {
		"caption": "ЭКОНОМ-1 DO-3"
	},
	"tc_6_96_114": {
		"caption": "ЭКОНОМ-1 Контур БАКА"
	},
	"tc_6_96_115": {
		"caption": "ЭКОНОМ-1 Н-1"
	},
	"tc_6_96_116": {
		"caption": "ЭКОНОМ-1 Н-2"
	},
	"tc_6_96_117": {
		"caption": "ЭКОНОМ-1 ПИК"
	},
	"tc_6_96_118": {
		"caption": "ЭКОНОМ-1 ПЛУПИК"
	},
	"tc_6_96_121": {
		"caption": "ЭКОНОМ-1 АВТ.КОНТУР-1"
	},
	"tc_6_96_122": {
		"caption": "ЭКОНОМ-1 АВТ.КОНТУР-2"
	},
	"tc_6_96_123": {
		"caption": "ЭКОНОМ-1 АВТ.КОНТУР-3"
	},
	"tc_6_96_131": {
		"caption": "ЭКОНОМ-1 АВТ.НАСОС-1"
	},
	"tc_6_96_132": {
		"caption": "ЭКОНОМ-1 АВТ.НАСОС-2"
	},
	"tc_6_96_133": {
		"caption": "ЭКОНОМ-1 АВТ.НАСОС-3"
	},
	"tc_6_96_134": {
		"caption": "ЭКОНОМ-1 АВТ.НАСОС-4"
	},
	"tc_6_96_200": {
		"caption": "ЭКОНОМ-1 Нет связи"
	},
	"tc_6_96_501": {
		"caption": "Норма уровня бака аккумулятора"
	},
	"tc_6_96_502": {
		"caption": "Низкий уровень в баке аккумуляторе"
	},
	"tc_6_96_500": {
		"caption": "Высокий уровень в баке аккумуляторе"
	},
	"tc_6_-1_62": {
		"caption": "Связь с ІТП Елекон (RS)"
	},
	"tc_6_-1_92": {
		"caption": "Связь с КП ІТП Елекон"
	},
	"tc_6_93_202": {
		"caption": "EDISON-22 включен"
	},
	"tc_6_97_0": {
		"caption": "A2. Нет связи"
	},
	"tc_6_97_1": {
		"caption": "КОДАС-20Т-1 КМ-1\"АВР Ввод от ВРУ\""
	},
	"tc_6_97_200": {
		"caption": "КОДАС-20Т-1 Нет связи"
	},
	"tc_6_97_2": {
		"caption": "КОДАС-20Т-1 КМ-2\"АВР Ввод от ДГ\""
	},
	"tc_6_97_3": {
		"caption": "КОДАС-20Т-1 KV-1 Котроль напряжения \"Ввод от ВРУ\""
	},
	"tc_6_97_4": {
		"caption": "КОДАС-20Т-1 KV-2 Котроль напряжения \"Ввод от ДГ\""
	},
	"tc_6_97_5": {
		"caption": "КОДАС-20Т-1 QF-6 Эл.питание котла \"Эдисон-22\""
	},
	"tc_6_97_6": {
		"caption": "КОДАС-20Т-1 QF-7 Эл.питание \"Насос-1\""
	},
	"tc_6_97_7": {
		"caption": "КОДАС-20Т-1 QF-8 Эл.питание \"Насос-2\""
	},
	"tc_6_97_8": {
		"caption": "КОДАС-20Т-1 QF-9 Эл.питание \"Вентилятор-1\""
	},
	"tc_6_97_9": {
		"caption": "КОДАС-20Т-1 QF-10 Эл.питание \"Вентилятор-2\""
	},
	"tc_6_97_10": {
		"caption": "КОДАС-20Т-1 QF-11 Эл.питание \"ШЛАСМУ\""
	},
	"tc_6_97_11": {
		"caption": "КОДАС-20Т-1 КМ-3\"Насос-1\""
	},
	"tc_6_97_12": {
		"caption": "КОДАС-20Т-1 КМ-4\"Насос-2\""
	},
	"tc_6_97_13": {
		"caption": "КОДАС-20Т-1 QF-5\"Ввод от ДГ\""
	},
	"tc_6_97_14": {
		"caption": "КОДАС-20Т-1 QF-4\"Ввод от ВРУ\""
	},
	"tc_6_97_15": {
		"caption": "КОДАС-20Т-1 QF-2 Эл.питание котла\"Эдисон-100\""
	},
	"tc_6_97_16": {
		"caption": "КОДАС-20Т-1 ДД-3 \"Давление в системе\""
	},
	"tc_6_97_17": {
		"caption": "КОДАС-20Т-1 Авария котла \"Эдисон-22\""
	},
	"tc_6_112_3": {
		"caption": "ЕК-1. Состояние котла"
	},
	"tc_6_112_0": {
		"caption": "ЕК-1. Нет связи"
	},
	"tc_6_115_16": {
		"caption": "ЕК-3. Авария циркуляционного насоса"
	},
	"tc_6_115_4": {
		"caption": "ЕК-3. Состояние циркуляционного насоса"
	},
	"tc_6_115_3": {
		"caption": "ЕК-3. Состояние котла"
	},
	"tc_6_115_0": {
		"caption": "ЕК-3. Нет связи"
	},
	"tc_6_118_3": {
		"caption": "ЕК-2. Состояние котла"
	},
	"tc_6_118_0": {
		"caption": "ЕК-2. Нет связи"
	},
	"tc_6_112_400": {
		"caption": "ЕК-1. Авария общая"
	},
	"tc_6_115_400": {
		"caption": "ЕК-3. Авария общая"
	},
	"tc_6_118_400": {
		"caption": "ЕК-2.Авария общая"
	},
	"tc_6_118_16": {
		"caption": "ЕК-2. Авария циркуляционного насоса"
	},
	"tc_6_127_100": {
		"caption": "Режим работы ЗимаЛето"
	}
};


//////////////////
// WEBPACK FOOTER
// ./params.json
// module id = 312
// module chunks = 0